<template>
	<div class="customer-area-page">
		<b-container>
			<b-row>
				<b-col md="3">
					<Navigation
						page="security"
					/>
				</b-col>
				<b-col md="8">
					<h1>Daten & Sicherheit</h1>
					<Info
						:meta="meta"
						:get-security="getSecurity"
						:change-identification="changeIdentification"
						:resend-resend-function="resendResendFunction"
						:resend-change-function="resendChangeFunction"
						with-identification
						with-search-permission
					/>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import Navigation from "@/vue/customer-area/Navigation"
import Info from "@/vue/legitimation/security/Info"
import Get from "@/api/customer/security/Get";
import Change from "@/api/customer/identification/Change";
import LegitimationResend from "@/api/customer/legitimation/Resend";
import LegitimationLegitimate from "@/api/customer/legitimation/Legitimate";
import {mapState} from "vuex";

export default {

	components: {
		Info,
		Navigation,
	},

	computed: {
		...mapState('meta', [
			'meta'
		])
	},

	methods: {
		async getSecurity ()
		{
			const response = await new Get()
				.call();

			return response.data;
		},
		async changeIdentification (identification)
		{
			const change = new Change()
				.setDocumentType(identification.documentType);

			if (identification.identificationId)
			{
				change.setIdentificationId(identification.identificationId)
			}

			if (identification.file)
			{
				change.setFile(identification.file);
			}

			return change.call();
		},
		async resendResendFunction ({type})
		{
			return new LegitimationResend()
				.setType(type)
				.call();
		},
		async resendChangeFunction ({type, code})
		{
			return new LegitimationLegitimate()
				.setType(type)
				.setValue(code)
				.call();
		},
	}
}
</script>
